import React, { useLayoutEffect, useState } from "react";
import * as PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import fbConfig from "../utils/fbConfig";
import { Button, withTheme, IconButton, withStyles } from "@material-ui/core";
import { Brightness7, Brightness2 } from "@material-ui/icons";
import { GoogleLogin } from "react-google-login";
import { loginApp } from "../contexts/GlobalProviders";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { version } from "../../package.json";
import { getBrowserFamily } from "../utils/browser";
import { ReactSVG as Svg } from "react-svg";

const styles = (theme) => ({
    root: {
        color: "white",
        margin: "0 auto",
        height: "100%",
        maxHeight: "100vh",
        background: theme.background,
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    toggleButton: {
        position: "absolute",
        top: 10,
        right: 10,
        color: theme.palette.type === "light" ? "#440099" : theme.palette.text.primary,
    },
    version: {
        color: "#6A6A6A",
        position: "absolute",
        bottom: 5,
        right: 15,
    },
    fontColor: {
        color: theme.palette.type === "light" ? "#440099" : theme.palette.text.primary,
        minWidth: 300,
    },
    logo: {
        marginBottom: 20,
        "& svg": {
            fill: theme.palette.type === "light" ? "#440099" : theme.palette.text.primary,
        },
    },
    loginButton: {
        color: "white",
        borderColor: "white",
    },
});

function DefaultPage(props) {
    const [loading, setLoading] = useState(true);

    let initTimeout;

    useLayoutEffect(() => {
        initTimeout = setTimeout(() => {
            setLoading(false);
        }, 5000);
        return () => clearTimeout(initTimeout);
    }, []);

    const toggleTheme = () => {
        props.theme.setCustomTheme(props.theme.palette.type === "light" ? "dark" : "light");
    };

    const { classes } = props;
    return (
        <Grid container direction={"column"} justifyContent={"center"} alignContent={"center"} alignItems={"center"} className={classes.root}>
            {loading ? (
                <Grid item md={4} sm={12} lg={3}>
                    <CircularProgress color="secondary" />
                </Grid>
            ) : (
                <Grid item md={4} sm={12} lg={4} className={classes.fontColor}>
                    <IconButton className={classes.toggleButton} onClick={toggleTheme}>
                        {props.theme.palette.type === "light" ? <Brightness2 /> : <Brightness7 />}
                    </IconButton>
                    {/*<Typography key={'welcome'} variant={'h5'} align={"center"}>
                            Bem-vindo
                        </Typography>
                        <Typography key={'to'} variant={'h6'} align={"center"}>
                            ao
                        </Typography>*/}
                    <Typography key={"MateraClock"} variant={"h4"} align={"center"}>
                        <Svg src={`${process.env.PUBLIC_URL}/images/logoClock.svg`} className={classes.logo} />
                    </Typography>
                    <GoogleLogin
                        scope={"profile email"}
                        onFailure={console.log}
                        key={"login"}
                        clientId={fbConfig.clientId}
                        render={(renderProps) => (
                            <Button color="inherit" className={classes.loginButton} variant={"outlined"} onClick={renderProps.onClick} fullWidth>
                                Login
                            </Button>
                        )}
                        approvalPrompt="force"
                        responseType="id_token"
                        accessType="online"
                        isSignedIn
                        redirectUri={process.env.REDIRECT_URI}
                        offline
                        prompt="consent"
                        uxMode={!getBrowserFamily("electron") ? "popup" : "redirect"}
                        onSuccess={loginApp}
                        fetchBasicProfile={true}
                        theme={"dark"}
                        cookiePolicy={"none"}
                    />
                </Grid>
            )}
            <Typography key={"to"} variant={"overline"} align={"center"} className={classes.version}>
                v{version}
            </Typography>
        </Grid>
    );
}

DefaultPage.propTypes = { onClick: PropTypes.func };

export default withTheme(withStyles(styles)(DefaultPage));
